import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SensoriseSimDataComponent } from './sensorise-sim-data-details.component';

const routes: Routes = [
  {
    path: 'sensorise-sim-data-details',
    data: { name: 'Add Production Devices', isTab: false },
    component: SensoriseSimDataComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SensoriseSimDataPageRoutingModule {}
